<template>
  <div class="py-1">
    <v-switch
      :input-value="promoFilter"
      inset
      label="Promozioni"
      dense
      @change="handlePromoFilter"
      class="pt-2 mt-0"
      hide-details
      @click="trackFilter('In evidenza', 'Promozioni', !promoFilter)"
    ></v-switch>
    <!-- <v-switch
      :input-value="newFilter"
      inset
      label="Novità"
      dense
      @change="handleNewFilter"
      class="pt-2 mt-0"
      hide-details
    ></v-switch> -->
  </div>
</template>

<script>
export default {
  name: "ProductPromoFilter",
  props: ["promoFilter", "newFilter"],
  methods: {
    handlePromoFilter(promo) {
      this.$emit("handlePromoFilter", promo);
    },
    handleNewFilter(onlyNew) {
      this.$emit("handleNewFilter", onlyNew);
    },
    trackFilter(filterType, filterValue, active) {
      console.log(filterType, filterValue, active);
      const event = active
        ? "applicazione-filtro-listing"
        : "rimozione-filtro-listing";
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event,
        filterType,
        filterValue
      });
    }
  }
};
</script>

<style></style>
